module.exports = __webpack_public_path__ + "media/public/images/slider/banner_mobile-5ef8576d155f614fb9d023ec0f3a2800.png";